import React from "react";
import AdtaDevicePage from "../devicemanagement/adtadevice/AdtaDevicePage";
import AslDevicePage from "../devicemanagement/asldevice/AslDevicePage";
import AdtaDeviceOverview from "../devicemanagement/adtadevice/AdtaDeviceOverview";
import AdtaDeviceConfiguration from "../devicemanagement/adtadevice/AdtaDeviceConfiguration";
import AdtaDeviceLogstream from "../devicemanagement/adtadevice/AdtaDeviceLogstream";
import AslDeviceOverview from "../devicemanagement/asldevice/AslDeviceOverview";
import AslDeviceConfiguration from "../devicemanagement/asldevice/AslDeviceConfiguration";
import AslDeviceLogstream from "../devicemanagement/asldevice/AslDeviceLogstream";
import ThinClientOverview from "../devicemanagement/thinclient/ThinClientOverview";
import SblDeviceOverview from "../devicemanagement/sbldevice/SblDeviceOverview";
import SblDeviceConfiguration from "../devicemanagement/sbldevice/SblDeviceConfiguration";
import ThinClientPage from "../devicemanagement/thinclient/ThinClientPage";

import LidarOverview from "../devicemanagement/lidar/LidarOverview";
import LidarManageByExceptions from "../devicemanagement/lidar/LidarManageByExceptions";
import LidarPage from "../devicemanagement/lidar/LidarPage";
import LEDControllerOverview from "../devicemanagement/ledcontroller/LEDControllerOverview";
import LEDControllerConfiguration from "../devicemanagement/ledcontroller/LEDControllerConfiguration";
import SBLDashboard from "../devicemanagement/ledcontroller/SBLDashboard";
import LEDControllerPage from "../devicemanagement/ledcontroller/LEDControllerPage";
import BinTester from "../devicemanagement/ledcontroller/bintester";
import AisleConfigFinder from "../devicemanagement/ledcontroller/aisleconfig/AisleConfigFinder";
import TrafficLightPage from "../devicemanagement/trafficlightdevice/TrafficLightPage";
import TrafficLightControllerSelectPage from "../devicemanagement/trafficlightdevice/TrafficLightControllerSelectPage";
import TrafficLightControllerOverview from "../devicemanagement/trafficlightdevice/TrafficLightControllerOverview";
import AdtfDeviceOverview from "../devicemanagement/adtfdevice/AdtfDeviceOverview";
import AdtfDeviceConfiguration from "../devicemanagement/adtfdevice/AdtfDeviceConfiguration";
import AdtfMatrixPage from "../devicemanagement/adtfdevice/AdtfMatrixPage";
import AdtfDeviceLogstream from "../devicemanagement/adtfdevice/AdtfDeviceLogstream";
import AdtaDeviceValidation from "../devicemanagement/adtadevice/AdtaDeviceValidation";
import AslDeviceValidation from "../devicemanagement/asldevice/AslDeviceValidation";
import ZancaSortDevicePage from "../devicemanagement/zancasort/ZancaSortDevicePage";
import ZancaSortDeviceOverview from "../devicemanagement/zancasort/ZancaSortDeviceOverview";
import TesseractDevicePage from "../devicemanagement/tesseract/TesseractDevicePage";
import TesseractDeviceOverview from "../devicemanagement/tesseract/TesseractDeviceOverview";
import ZancaSortDeviceConfiguration from "../devicemanagement/zancasort/ZancaSortDeviceConfiguration";
import TesseractDeviceConfiguration from "../devicemanagement/tesseract/TesseractDeviceConfiguration";
import AutoRetrieverDeviceOverview from "../devicemanagement/autoretriever/AutoRetrieverDeviceOverview";
import AutoRetrieverDevicePage from "../devicemanagement/autoretriever/AutoRetrieverDevicePage";
import BagTrackingPage from "../devicemanagement/bagtracking/BagTrackingPage";
import ZancaSortDeviceLogstream from "../devicemanagement/zancasort/ZancaSortDeviceLogstream";
import TesseractDeviceLogstream from "../devicemanagement/tesseract/TesseractDeviceLogstream";
import AutoRetrieverDeviceLogstream from "../devicemanagement/autoretriever/AutoRetrieverDeviceLogstream";
import AsmlSubComponentSelectPage from "../devicemanagement/asmldevice/AsmlSubComponentSelectPage";
import AsmlProtocolValidationSubComponentSelectionPage from "../devicemanagement/asmldevice/AsmlProtocolValidationSubComponentSelectionPage";
import InductCameraDeviceValidation from "../devicemanagement/asmldevice/InductCameraDeviceValidation";
import VerificationCameraDeviceValidation from "../devicemanagement/asmldevice/VerificationCameraDeviceValidation";
import InductCameraDevicePage from "../devicemanagement/asmldevice/InductCameraDevicePage";
import InductCameraDeviceOverview from "../devicemanagement/asmldevice/InductCameraDeviceOverview";
import PrinterDeviceOverview from "../devicemanagement/asmldevice/PrinterDeviceOverview";
import PrinterDevicePage from "../devicemanagement/asmldevice/PrinterDevicePage";
import AutoRetrieverDeviceConfiguration from "../devicemanagement/autoretriever/AutoRetrieverDeviceConfiguration";
import VerificationCameraDeviceOverview from "../devicemanagement/asmldevice/VerificationCameraDeviceOverview";
import VerificationCameraDevicePage from "../devicemanagement/asmldevice/VerificationCameraDevicePage";
import AsmlDevicePage from "../devicemanagement/asmldevice/AsmlDevicePage";
import HandsfreeCameraDevicePage from "../devicemanagement/asmldevice/HandsfreeCameraDevicePage";
import HandsfreeCameraDeviceOverview from "../devicemanagement/asmldevice/HandsfreeCameraDeviceOverview";
import OverheadCameraDevicePage from "../devicemanagement/asmldevice/OverheadCameraDevicePage";
import OverheadCameraDeviceOverview from "../devicemanagement/asmldevice/OverheadCameraDeviceOverview";
import AsmlDeviceOverview from "../devicemanagement/asmldevice/AsmlDeviceOverview";
import AsmlDeviceLogstream from "../devicemanagement/asmldevice/AsmlDeviceLogStream";
import {IS_AUTO_LOADER_ENABLED, IS_BAG_TRACKING_ALLOWED, IS_VAPR_ENABLED} from "./Util";
import {FeatureUtility, FEATURES} from "./FeatureUtility";
import LidarTesterTool from "../devicemanagement/lidar/LidarTesterTool";
import AutoLoaderDevicePage from "../devicemanagement/autoloader/AutoLoaderDevicePage";
import AutoLoaderDeviceOverview from "../devicemanagement/autoloader/AutoLoaderDeviceOverview";
import AutoLoaderDeviceConfiguration from "../devicemanagement/autoloader/AutoLoaderDeviceConfiguration";
import AutoLoaderDeviceLogstream from "../devicemanagement/autoloader/AutoLoaderDeviceLogstream";
import AdtfSubComponentSelectPage from "../devicemanagement/adtfdevice/AdtfSubComponentSelectPage";
import AdtfPullModePage from "../devicemanagement/adtfdevice/AdtfPullModePage";
import AdtfSimplePage from "../devicemanagement/adtfdevice/AdtfSimplePage";
import AdtfDevicePage from "../devicemanagement/adtfdevice/AdtfDevicePage";
import {ADTF_ASSET_TYPE} from "./Constants";
import LEDControllerSTAGPage from "../devicemanagement/ledcontrollerstag/LEDControllerSTAGPage";
import VaprDevicePage from "../devicemanagement/vaprdevice/VaprDevicePage";
import VaprDeviceOverview from "../devicemanagement/vaprdevice/VaprDeviceOverview";

export const DEFAULT_ROUTES = {
    "/devicemanagement/asl": "/devicemanagement/asl/overview",
    "/devicemanagement/adta": "/devicemanagement/adta/overview",
    "/devicemanagement/adtfmatrix": "/devicemanagement/adtfmatrix/overview",
    "/devicemanagement/adtf/matrix": "/devicemanagement/adtf/matrix/overview",
    "/devicemanagement/adtf/simple": "/devicemanagement/adtf/simple/overview",
    "/devicemanagement/adtf/pullmode": "/devicemanagement/adtf/pullmode/overview",
    "/devicemanagement/thinclient": "/devicemanagement/thinclient/overview",
    "/devicemanagement/asml/inductcamera": "/devicemanagement/asml/inductcamera/overview",
    "/devicemanagement/asml/printer": "/devicemanagement/asml/printer/overview",
    "/devicemanagement/asml/verificationcamera" : "/devicemanagement/asml/verificationcamera/overview",
    "/devicemanagement/asml/handsfreecamera" : "/devicemanagement/asml/handsfreecamera/overview",
    "/devicemanagement/asml/overheadcamera" : "/devicemanagement/asml/overheadcamera/overview",
    "/devicemanagement/asml/asml": "/devicemanagement/asml/asml/overview",
    "/devicemanagement/sbl": "/devicemanagement/sbl/overview",
    "/devicemanagement/lidar": "/devicemanagement/lidar/overview",
    "/devicemanagement/ledcontroller": "/devicemanagement/ledcontroller/overview",
    "/devicemanagement/ledcontrollerstag": "/devicemanagement/ledcontrollerstag/sbldashboard",
    "/devicemanagement/trafficlight": "/devicemanagement/trafficlight/overview",
    "/devicemanagement/zancasort": "/devicemanagement/zancasort/overview",
    "/devicemanagement/tesseract": "/devicemanagement/tesseract/overview",
    "/devicemanagement/autoretriever": "/devicemanagement/autoretriever/overview",
    "/devicemanagement/bagtracking": "/devicemanagement/bagtracking/overview",
    "/devicemanagement/autoloader": "/devicemanagement/autoloader/overview",
    "/devicemanagement/vapr": "/devicemanagement/vapr/overview",
};

export const BAG_TRACKING_ROUTE = [
    {
        name: "Bag Tracking",
        path: "/devicemanagement/bagtracking",
        id: "bagtracking.heading",
        component: (props) => {
            return (<BagTrackingPage history={props.history} location={props.location}/>)
        }
    }
];

export const AUTO_LOADER_ROUTE = [
    {
        name: "Auto Loader",
        path: "/devicemanagement/autoloader",
        id: "autoloader.heading",
        component: (props) => {
            return (<AutoLoaderDevicePage history={props.history} location={props.location} />)
        },
    }
];

export const VAPR_ROUTE = [
    {
        name: "VAPR",
        path: "/devicemanagement/vapr",
        id: "vapr.heading",
        component: (props) => {
            return (<VaprDevicePage history={props.history} location={props.location}/>)
        },
    }
];

const BASE_ROUTES = [
    {
        name: "ADTA",
        path: "/devicemanagement/adta",
        id: "adta.heading",
        component: (props) => {
            return (<AdtaDevicePage history={props.history} location={props.location} isADTR={false}/>)
        },
    }, {
        name: "ADTF Matrix",
        path: "/devicemanagement/adtfmatrix",
        id: "adtf.heading",
        component: (props) => {
            return (<AdtfDevicePage history={props.history} location={props.location}/>)
        },
    }, {
        name: "ADTF",
        path: "/devicemanagement/adtf",
        id: "adtf.heading",
        component: (props) => {
            return (<AdtfSubComponentSelectPage history={props.history} location={props.location}/>)
        },
    }, {
        name: "ASL",
        path: "/devicemanagement/asl",
        id: "asl.heading",
        component: (props) => {
            return (<AslDevicePage history={props.history} location={props.location}/>)
        },
    },{
        name: "Thin Client",
        path: "/devicemanagement/thinclient",
        id: "thinclients.heading",
        component: (props) => {
            return (<ThinClientPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Lidar Controller",
        path: "/devicemanagement/lidar",
        id: "lidar.heading",
        component: (props) => {
            return (<LidarPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "LED Controller",
        path: "/devicemanagement/ledcontroller",
        id: "ledcontroller.heading",
        component: (props) => {
            return (<LEDControllerPage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "ZancaSort",
        path: "/devicemanagement/zancasort",
        id: "zancasort.heading",
        component: (props) => {
            return (<ZancaSortDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Tesseract",
        path: "/devicemanagement/tesseract",
        id: "tesseract.heading",
        component: (props) => {
            return (<TesseractDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "Auto Retriever",
        path: "/devicemanagement/autoretriever",
        id: "autoretriever.heading",
        component: (props) => {
            return (<AutoRetrieverDevicePage history={props.history} location={props.location}/>)
        }
    },
    {
        name: "ASML",
        path: "/devicemanagement/asml",
        id: "asml.heading",
        component: (props) => {
            return (<AsmlSubComponentSelectPage history={props.history} location={props.location}/>)
        },
    },
    ...(IS_BAG_TRACKING_ALLOWED ? BAG_TRACKING_ROUTE : []),
    ...(IS_AUTO_LOADER_ENABLED ? AUTO_LOADER_ROUTE : []),
    ...(IS_VAPR_ENABLED ? VAPR_ROUTE : []),
    {
        name: "LED Controller(STAG)",
        path: "/devicemanagement/ledcontrollerstag",
        id: "ledcontrollerstag.heading",
        component: (props) => {
            return (<LEDControllerSTAGPage history={props.history} location={props.location}/>)
        }
    },
];

export const DEVICE_MANAGEMENT_ROUTES = () => {
    const isAdtfSubtypeEnabled = FeatureUtility.getFeatureStatus(FEATURES.IS_ADTF_SUBTYPE_ENABLED);
    
    return BASE_ROUTES.filter(route => {
        if (!isAdtfSubtypeEnabled && route.name === ADTF_ASSET_TYPE) {
            return false;
        }
        return true;
    });
};
export const TRAFFIC_LIGHT_ROUTES = [
    {
        name: "Traffic Light",
        path: "/devicemanagement/trafficlight",
        id: "trafficlight.heading",
        component: (props) => {
            return (<TrafficLightPage history={props.history} location={props.location}/>)
        }
    }
]

export const ADTA = [
    {
        name: "overview",
        path: "/devicemanagement/adta/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtaDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adta/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtaDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adta/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtaDeviceLogstream/>)
        },
    }
];

export const adtaMheValidationRoute = {
    name: "validation",
    path: "/devicemanagement/adta/validation",
    id: "tab.validation",
    component: () => {
        return (<AdtaDeviceValidation/>)
    },
}

export const ADTF = [
    {
        name: "overview",
        path: "/devicemanagement/adtfmatrix/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtfDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adtfmatrix/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtfDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adtfmatrix/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtfDeviceLogstream/>)
        }
    }
];

export const ADTF_MATRIX_ROUTE = [
    {
        name: "overview",
        path: "/devicemanagement/adtf/matrix/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtfDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adtf/matrix/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtfDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adtf/matrix/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtfDeviceLogstream/>)
        }
    }
];

export const ADTF_SIMPLE_ROUTE = [
    {
        name: "overview",
        path: "/devicemanagement/adtf/simple/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtfDeviceOverview/>)
        },
    },
    {
        name: "configuration",
        path: "/devicemanagement/adtf/simple/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtfDeviceConfiguration/>)
        },
    },
    {
        name: "logstream",
        path: "/devicemanagement/adtf/simple/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtfDeviceLogstream/>)
        }
    }
];

export const ADTF_PULLMODE_ROUTE = [
    {
        name: "overview",
        path: "/devicemanagement/adtf/pullmode/overview",
        id: "tab.overview",
        component: () => {
            return (<AdtfDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/adtf/pullmode/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AdtfDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/adtf/pullmode/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AdtfDeviceLogstream/>)
        }
    }
];

export const ASL = [
    {
        name: "overview",
        path: "/devicemanagement/asl/overview",
        id: "tab.overview",
        component: () => {
            return (<AslDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/asl/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AslDeviceConfiguration/>)
        },
    },
    {
        name: "logstream",
        path: "/devicemanagement/asl/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AslDeviceLogstream/>)
        },
    }
];

export const ZANCA_SORT = [
    {
        name: "overview",
        path: "/devicemanagement/zancasort/overview",
        id: "tab.overview",
        component: () => {
            return (<ZancaSortDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/zancasort/configuration",
        id: "tab.configuration",
        component: () => {
            return (<ZancaSortDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/zancasort/logstream",
        id: "tab.logstream",
        component: () => {
            return (<ZancaSortDeviceLogstream/>)
        },
    }
];

export const TESSERACT = [
    {
        name: "overview",
        path: "/devicemanagement/tesseract/overview",
        id: "tab.overview",
        component: () => {
            return (<TesseractDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/tesseract/configuration",
        id: "tab.configuration",
        component: () => {
            return (<TesseractDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/tesseract/logstream",
        id: "tab.logstream",
        component: () => {
            return (<TesseractDeviceLogstream/>)
        },
    }
];

export const AUTO_RETRIEVER = [
    {
        name: "overview",
        path: "/devicemanagement/autoretriever/overview",
        id: "tab.overview",
        component: () => {
            return (<AutoRetrieverDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/autoretriever/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AutoRetrieverDeviceConfiguration/>)
        },
    }, {
        name: "logstream",
        path: "/devicemanagement/autoretriever/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AutoRetrieverDeviceLogstream/>)
        },
    }
];

export const AUTO_LOADER = [
    {
        name: "overview",
        path: "/devicemanagement/autoloader/overview",
        id: "tab.overview",
        component: () => {
            return (<AutoLoaderDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/autoloader/configuration",
        id: "tab.configuration",
        component: () => {
            return (<AutoLoaderDeviceConfiguration/>)
        }
    }, {
        name: "logstream",
        path: "/devicemanagement/autoloader/logstream",
        id:  "tab.logstream",
        component: () => {
            return (<AutoLoaderDeviceLogstream/>)
        }
    }
    ];

export const VAPR = [
    {
        name: "overview",
        path: "/devicemanagement/vapr/overview",
        id: "tab.overview",
        component: () => {
            return (<VaprDeviceOverview/>)
        },
    }
];

export const ADTF_SUB_COMPONENT_ROUTES = [
    {
        name: "Matrix",
        path: "/devicemanagement/adtf/matrix",
        id: "adtf.matrix.heading",
        component: (props) => {
            return (<AdtfMatrixPage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "Simple",
        path: "/devicemanagement/adtf/simple",
        id: "adtf.simple.heading",
        component: (props) => {
            return (<AdtfSimplePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "PullMode",
        path: "/devicemanagement/adtf/pullmode",
        id: "adtf.pullmode.heading",
        component: (props) => {
            return (<AdtfPullModePage history={props.history} location={props.location}/>)
        },
    }
];

export const IN_SITE_ASML_SUB_COMPONENT_ROUTES = [
    {
        name: "HANDSFREE CAMERA",
        path: "/devicemanagement/asml/handsfreecamera",
        id: "asml.handsfreecamera.heading",
        component: (props) => {
            return (<HandsfreeCameraDevicePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "OVERHEAD CAMERA",
        path: "/devicemanagement/asml/overheadcamera",
        id: "asml.overheadcamera.heading",
        component: (props) => {
            return (<OverheadCameraDevicePage history={props.history} location={props.location}/>)
        },
    }
];

export const ASML_SUB_COMPONENT_ROUTES = [
    {
        name: "INDUCT CAMERA",
        path: "/devicemanagement/asml/inductcamera",
        id: "asml.inductCamera.heading",
        component: (props) => {
            return (<InductCameraDevicePage history={props.history} location={props.location}/>)
        },
    }, {
        name: "PRINTER",
        path: "/devicemanagement/asml/printer",
        id: "asml.printer.heading",
        component: (props) => {
            return (<PrinterDevicePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "VERIFICATION CAMERA",
        path: "/devicemanagement/asml/verificationcamera",
        id: "asml.verificationcamera.heading",
        component: (props) => {
            return (<VerificationCameraDevicePage history={props.history} location={props.location}/>)
        },
    },
    {
        name: "ASML",
        path: "/devicemanagement/asml/asml",
        id: "asml.asml.heading",
        component: (props) => {
            return (<AsmlDevicePage history={props.history} location={props.location}/>)
        },
    }
];

export const ASML_SUB_COMPONENT_VALIDATION_ROUTES = [
    {
        name: "INDUCT CAMERA",
        path: "/devicemanagement/asml/asml/validation/inductcamera",
        id: "asml.inductCamera.heading",
        component: () => {
            return (<InductCameraDeviceValidation/>)
        },
    },
    /*  Printer doesn't send any kind messages to TC. Hence, we can't validate Protocol for printer in the way
        we do it for other device. We have to make architectural change in backend to support validation for
        printer. Keeping printer validation disabled un-till the backend is ready.
    {
        name: "PRINTER",
        path: "/devicemanagement/asml/asml/validation/printer",
        id: "asml.printer.heading",
        component: () => {
            return (<PrinterDeviceValidation/>)
        },
    },*/
    {
        name: "VERIFICATION CAMERA",
        path: "/devicemanagement/asml/asml/validation/verificationcamera",
        id: "asml.verificationcamera.heading",
        component: () => {
            return (<VerificationCameraDeviceValidation/>)
        },
    }
];

export const INDUCT_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/inductcamera/overview",
        id: "tab.overview",
        component: () => {
            return (<InductCameraDeviceOverview/>)
        }
    }
];

export const PRINTER = [
    {
        name: "overview",
        path: "/devicemanagement/asml/printer/overview",
        id: "tab.overview",
        component: () => {
            return (<PrinterDeviceOverview/>)
        }
    }
];

export const VERIFICATION_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/verificationcamera/overview",
        id: "tab.overview",
        component: () => {
            return (<VerificationCameraDeviceOverview/>)
        }
    }
];

export const HANDSFREE_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/handsfreecamera/overview",
        id: "tab.overview",
        component: () => {
            return (<HandsfreeCameraDeviceOverview/>)
        }
    }
];

export const OVERHEAD_CAMERA = [
    {
        name: "overview",
        path: "/devicemanagement/asml/overheadcamera/overview",
        id: "tab.overview",
        component: () => {
            return (<OverheadCameraDeviceOverview/>)
        }
    }
];

export const ASML = [
    {
        name: "overview",
        path: "/devicemanagement/asml/asml/overview",
        id: "tab.overview",
        component: () => {
            return (<AsmlDeviceOverview/>)
        }
    },
    {
        name: "logstream",
        path: "/devicemanagement/asml/asml/logstream",
        id: "tab.logstream",
        component: () => {
            return (<AsmlDeviceLogstream/>)
        },
    },
    {
        name: "validation",
        path: "/devicemanagement/asml/asml/validation",
        id: "tab.validation",
        component: (props) => {
            return (<AsmlProtocolValidationSubComponentSelectionPage history={props.history} location={props.location}/>)
        },
    }
];


export const aslMheValidationRoute = {
    name: "validation",
    path: "/devicemanagement/asl/validation",
    id: "tab.validation",
    component: () => {
        return (<AslDeviceValidation/>)
    },
}

export const THIN_CLIENTS = [
    {
        name: "overview",
        path: "/devicemanagement/thinclient/overview",
        id: "tab.overview",
        component: () => {
            return (<ThinClientOverview/>)
        },
    }
];

export const SBL = [
    {
        name: "overview",
        path: "/devicemanagement/sbl/overview",
        id: "tab.overview",
        component: () => {
            return (<SblDeviceOverview/>)
        },
    }, {
        name: "configuration",
        path: "/devicemanagement/sbl/configuration",
        id: "tab.configuration",
        component: () => {
            return (<SblDeviceConfiguration/>)
        },
    }
];

export const LIDARS = [
    {
        name: "overview",
        path: "/devicemanagement/lidar/overview",
        id: "tab.overview",
        component: () => {
            return (<LidarOverview/>)
        },
    },
    {
        name: "manageByExceptions",
        path: "/devicemanagement/lidar/managebyexceptions",
        id: "tab.managebyexceptions",
        component: () => {
            return (<LidarManageByExceptions/>)
        }
    },
    {
        name: "lidarTester",
        path: "/devicemanagement/lidar/tester",
        id: "tab.lidartester",
        component: () => {
            return (<LidarTesterTool/>)
        }
    }
];

export const TRAFFIC_LIGHTS = [
    {
        name: "overview",
        path: "/devicemanagement/trafficlight/overview",
        id: "tab.overview",
        component: () => {
            return (<TrafficLightControllerOverview/>)
        },
    },
    {
        name: "trafficlight",
        path: "/devicemanagement/trafficlight/lightControls",
        id: "tab.trafficlight",
        component: () => {
            return (<TrafficLightControllerSelectPage/>)
        },
    }
];

export const LED_CONTROLLERS = [
    {
        name: "overview",
        path: "/devicemanagement/ledcontroller/overview",
        id: "tab.overview",
        component: () => {
            return (<LEDControllerOverview/>)
        }
    },
    {
        name: "testing",
        path: "/devicemanagement/ledcontroller/testing",
        id: "tab.testing",
        component: () => {
            return (<BinTester/>)
        }
    },
    {
        name: "aisleconfig",
        path: "/devicemanagement/ledcontroller/aisleconfig",
        id: "tab.aisleconfigfinder",
        component: () => {
            return (<AisleConfigFinder/>)
        }
    }
];

export const LED_CONTROLLERS_WITH_CONFIG = [
    {
        name: "overview",
        path: "/devicemanagement/ledcontroller/overview",
        id: "tab.overview",
        component: () => {
            return (<LEDControllerOverview/>)
        }
    },
    {
        name: "testing",
        path: "/devicemanagement/ledcontroller/testing",
        id: "tab.testing",
        component: () => {
            return (<BinTester/>)
        }
    },
    {
        name: "configuration",
        path: "/devicemanagement/ledcontroller/configuration",
        id: "tab.configuration",
        component: () => {
            return (<LEDControllerConfiguration/>)
        }
    },
    {
        name: "aisleconfig",
        path: "/devicemanagement/ledcontroller/aisleconfig",
        id: "tab.aisleconfigfinder",
        component: () => {
            return (<AisleConfigFinder/>)
        }
    }
];

export const LED_CONTROLLER_STAG_ROUTES = [
    {
        name: "SBL Dashboard",
        path: "/devicemanagement/ledcontrollerstag/sbldashboard",
        id: "tab.sbldashboard",
        component: () => {
            return (<SBLDashboard/>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/util/RouteConstants.js